angular.module('impactx.catalogruleresult').controller('CatalogRulePriceChangeListCtrl',
    CatalogRulePriceChangeListCtrl);

CatalogRulePriceChangeListCtrl.$inject = ['$routeParams'];

function CatalogRulePriceChangeListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogrulepricechangelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/rulepricechangelist',
        id: "catalogrulepricechangelist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}